import React from 'react';
import './style.scss';

const GraphTitle = ({ className = '', children }) => {
	return <h4 className={`graph-title ${className}`}>{children}</h4>;
};

export default GraphTitle;
